import type { GameMeta } from '@gmp/game-sdk';

/**
 * Expansion Pack 01 modes that are designed but not built yet. They appear in menus as "Planned" cards and
 * can never be selected or started. Names are working titles (no trademark clearance has been done).
 */
export interface PlannedGame {
  id: string;
  name: string;
  tagline: string;
  genre: string;
  verb: string;
  players: [number, number];
  minutes: [number, number];
  controls: GameMeta['controls'];
  rules: string;
  theme: { primary: string; secondary: string; background: string; ink: string };
  icon: 'gavel' | 'orbit' | 'bot' | 'meteor' | 'flame' | 'mountain' | 'pizza';
}

/** Every Expansion Pack 01 mode is built now; new planned modes go here. */
export const PLANNED_GAMES: PlannedGame[] = [];
